// Redesign 2026 – dopočítávání čísel (KPI „Proč e‑Finance?“, hodnota portfolia na homepage).
//
// Hodnota naskočí z nuly na cílové číslo, jakmile se prvek objeví ve výřezu, a jen jednou.
// Cíl animace je přesně ten text, který je v HTML: poslední snímek ho vrátí znak po znaku,
// takže na stránce nikdy nezůstane jinak naformátované číslo. (Legacy `.jscounter` v js/main.js
// tímhle trpí – `parseFloat("633,44")` u desetinných hodnot utne desetiny.)
//
// Markup: <span data-rd-count>513,41 mil. Kč</span>
// Číslo si modul v textu najde sám, text kolem něj („až“, jednotky, „%“) zůstává beze změny.
// Prvek bez čísla se přeskočí, takže hodnoty typu „Česká republika“ nevadí.
//
// Výpočty a formátování: ./counters-format.js (testy tests/redesign/counters-format.test.mjs).
import { parseValue, formatValue, easeOut } from './counters-format';

const SELECTOR = '[data-rd-count]';
const DURATION = 1400;

function animate(el) {
  const finalText = el.textContent;
  const value = parseValue(finalText);
  if (!value) {
    return;
  }

  // Mezihodnoty jsou kratší než cílové číslo; bez zafixované šířky by se obsah buňky
  // při každém snímku posouval. Po doběhnutí se rezervace zase uvolní.
  el.style.minWidth = el.getBoundingClientRect().width + 'px';

  const start = performance.now();

  const step = (now) => {
    const progress = Math.min((now - start) / DURATION, 1);

    if (progress === 1) {
      el.textContent = finalText; // poslední snímek = původní text beze změny
      el.style.minWidth = '';
      return;
    }

    el.textContent = formatValue(value.target * easeOut(progress), value);
    requestAnimationFrame(step);
  };

  requestAnimationFrame(step);
}

export default function initRedesignCounters() {
  const elements = document.querySelectorAll(SELECTOR);
  if (!elements.length) {
    return;
  }

  // Když uživatel animace nechce (nebo prohlížeč neumí IntersectionObserver), zůstane číslo
  // rovnou na cílové hodnotě – v HTML je od začátku, nic se nemusí dopisovat.
  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        observer.unobserve(entry.target); // animace proběhne jen jednou
        animate(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px' },
  );

  elements.forEach((el) => observer.observe(el));
}
